export default __webpack_public_path__ + "static/media/ChurrascoMenu.0f921c70.jpg";